import { env } from "@/src/common/constants/env";

type CometChatSdkModule = typeof import("@cometchat/chat-sdk-javascript");
type CometChatUiKitModule = typeof import("@cometchat/chat-uikit-react");

export interface CometChatSdk {
	CometChat: CometChatSdkModule["CometChat"];
	CometChatUIKit: CometChatUiKitModule["CometChatUIKit"];
}

let sdkPromise: Promise<CometChatSdk> | null = null;

async function importAndInit(): Promise<CometChatSdk> {
	const [sdkModule, uiKitModule] = await Promise.all([import("@cometchat/chat-sdk-javascript"), import("@cometchat/chat-uikit-react")]);

	const settings = new uiKitModule.UIKitSettingsBuilder()
		.setAppId(env.COMETCHAT_APP_ID)
		.setRegion(env.COMETCHAT_REGION)
		.subscribePresenceForFriends()
		.build();

	await uiKitModule.CometChatUIKit.init(settings);

	return { CometChat: sdkModule.CometChat, CometChatUIKit: uiKitModule.CometChatUIKit };
}

export function loadCometChatSdk(): Promise<CometChatSdk> {
	if (!sdkPromise) {
		sdkPromise = importAndInit().catch((error: unknown) => {
			sdkPromise = null;
			throw error;
		});
	}
	return sdkPromise;
}
